import { Component, computed, inject, input } from "@angular/core";
import { FilterMode, MarketSalesStateService } from "src/services/estate/market-sales-state.service";
import { EvAuthorizationService } from "src/util/auth0/ev-auth.service";

@Component({
    selector: "estate-filter-bar",
    templateUrl: "./estate-filter-bar.component.html",
    styleUrl: "./estate-filter-bar.component.scss",
})
export class EstateFilterBarComponent {
    private readonly mapStateService = inject(MarketSalesStateService);
    private readonly authorizationService = inject(EvAuthorizationService);

    readonly scrolled = input(false);

    readonly FilterMode = FilterMode;

    filterMode = this.mapStateService.filterMode;
    isFavoriteListFilterMode = this.mapStateService.isFavoriteListFilterMode;
    isUserFilterDirty = this.mapStateService.isUserFilterDirty;
    isStandardFilterDirty = this.mapStateService.isStandardFilterDirty;
    showModeToggle = this.authorizationService.isUniqueUser;

    isUserFilterMode = computed(() => !this.isFavoriteListFilterMode() && this.filterMode() === FilterMode.User);
    isStandardFilterMode = computed(() => !this.isFavoriteListFilterMode() && this.filterMode() === FilterMode.Standard);

    onSetFilterMode(mode: FilterMode): void {
        this.mapStateService.setFilterMode(mode);
    }

    onSaveUserFilter(): void {
        this.mapStateService.saveUserFilter();
    }

    onUndoUserFilter(): void {
        this.mapStateService.undoUserFilter();
    }
}
